import React, {useState, useEffect} from 'react';
import { commerce } from './lib/commerce';
import {Products, NavBar, Cart, Checkout, Footer, Resources, About} from './components';
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';

const App = () => {
  const [products, setProducts] = useState([])
  const [cart, setCart] = useState({});
  const [order, setOrder] = useState({});
  const [errorMessage, setErrorMessage] = useState('')

  const fetchProducts = async () => {
    const {data} = await commerce.products.list();
    setProducts(data);
  }

  const fetchCart = async () => {
    const c =  await commerce.cart.retrieve();
    setCart(c);
  }

  const handleAddToCart = async (productId, quantity) => {
    setCart(await commerce.cart.add(productId, quantity));
  }

  const handleUpdateCart =  async(productId, quantity) => {
    setCart(await commerce.cart.update(productId, {quantity}));

  }

  const handleRemoveCart =  async(productId) => {
    setCart(await commerce.cart.remove(productId));
  }

  const handleEmptyCart =  async() => {
    setCart(await commerce.cart.empty());
  }

  const refreshCart =  async() => {
    const newCart = await commerce.cart.refresh();
    console.log("in refresh Cart")
    setCart(newCart);
  }

  const handleCaptureCheckout = async (checkoutTokenId, newOrder) =>{
    try{
      const incomingOrder = await commerce.checkout.capture(checkoutTokenId, newOrder)
      setOrder(incomingOrder);
      console.log("in handle Capture Checkout")
      refreshCart();
    }catch(error){
      setErrorMessage(error.data.error.message);
    }
  }

  useEffect(()=>{
    fetchProducts();
    fetchCart();
  }, [])


  return (
    <Router>
        <NavBar cartItems={cart.total_items}/>
          <Routes>
            <Route path='/' element={<Products products={products} onAddToCart={handleAddToCart}/>}/>
            <Route path='/cart' element={<Cart 
              cart={cart}
              handleUpdateCart = {handleUpdateCart}
              handleRemoveCart = {handleRemoveCart}
              handleEmptyCart = {handleEmptyCart}
              />}/>
            <Route path='/checkout' element={
                <Checkout cart={cart}
                order={order}
                handleCaptureCheckout={handleCaptureCheckout}
                error={errorMessage}/>}/>
            <Route path='/resources' element={<Resources/>}/>
            <Route path='/about' element={<About/>}/>
          </Routes>
        <Footer/>
    </Router>
  )
}

export default App
